import angular from 'angular';
import {NavbarComponent} from './navbar.component.js';
import {SideNavigation} from './navigation.directive.js';

const navbar = angular.module('navbar', []);

navbar.component('navbar', NavbarComponent);
navbar.directive('sideNavigation', SideNavigation);

export {navbar};



// WEBPACK FOOTER //
// ./app/components/common/navbar/navbar.js